import { SettingOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Collapse, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { antIcon } from "../../Helpers/helpers";
import { accordianHead, alertData } from "../../Utils/constants";
import { HomeAlertsVar } from "../../Utils/variables";
import { useDispatch, useSelector } from 'react-redux'
import { getAlerts } from "../../API-Interaction/apiServices/kpis.api";
import { alert, FiAlertOctagon, IoAlertCircle } from "../../Utils/imports";
import moment from "moment";
import NoDataFound from "../../Components/Helpers/NoDataFound";
import Loader from "../../Components/Helpers/Loader";
const { Panel } = Collapse;
const { Option } = Select;
const { alerts, view_all } = HomeAlertsVar;


function HomeAlerts() {

  const dispatch = useDispatch()
  const { current } = useSelector(state => state.plant)
  const { alerts: alertsArray } = useSelector(state => state.kpis)
  const { componentLoaders } = useSelector(state => state.utils.loaders)
  useEffect(() => {
    current?.plant && getAlerts(dispatch, current)
  }, [current])

  const [expandIconPosition, setExpandIconPosition] = useState("start");

  const onPositionChange = (newExpandIconPosition) => {
    setExpandIconPosition(newExpandIconPosition);
  };

  const onChange = (key) => {
    // console.log(key);
  };

  const genExtra = (key) => (
    <CaretDownOutlined
      onClick={(event) => {
        console.log(key);
      }}
    />
  );

  return (
    <Loader indicator={antIcon} loading={componentLoaders.alerts}>
      <div className="boxBg boxBorder boxBorderRad p10">
        <div className="dflex alignCenter justifySB">
          <h3 className="cardHead">{alerts}</h3>
          <h4 style={{ color: "#1E6EFE", fontWeight: "bold", cursor: "pointer", margin: "0" }}>
            {view_all}
          </h4>
        </div>

        <div className="Alerts_Accordian">
          <Collapse
            defaultActiveKey={["0"]}
            onChange={onChange}
            className="bordernone dflex flexColumn gap5"
          >
            {alertsArray?.length ?
              alertsArray?.map((data, i) => (
                <Panel
                  header={
                    <div className="dflex accordianHeadCont">
                      {/* <IoAlertCircle style={{
                        background: "white",
                        color: "#EB5757",
                        fontSize:"20px"
                      }} /> */}
                      <img src={alert} />
                      <div className="accordianHead">
                        <h1>{data.title} | {data?.type}</h1>
                        <p>{moment(data.time).format('YYYY-MM-DD')} | {moment(data.time).format('hh:mm a')}</p>
                      </div>
                    </div>}
                  className="alertAccordian"
                  key={i}
                  showArrow={false}
                  extra={genExtra()}
                >
                  <div key={i} style={{ fontSize: "13px" }}>
                    {data.message}
                  </div>
                </Panel>
              ))
              :
              <NoDataFound />
            }
          </Collapse>
        </div>
      </div>
    </Loader>
  );
}

export default HomeAlerts;
